import { render, staticRenderFns } from "./legal-info.vue?vue&type=template&id=0f617c42&scoped=true"
import script from "./legal-info.vue?vue&type=script&lang=js"
export * from "./legal-info.vue?vue&type=script&lang=js"
import style0 from "./legal-info.vue?vue&type=style&index=0&id=0f617c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f617c42",
  null
  
)

export default component.exports